import { render, staticRenderFns } from "./liquidation.vue?vue&type=template&id=b8b6347a&scoped=true&"
import script from "./liquidation.vue?vue&type=script&lang=js&"
export * from "./liquidation.vue?vue&type=script&lang=js&"
import style0 from "./liquidation.vue?vue&type=style&index=0&id=b8b6347a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b6347a",
  null
  
)

export default component.exports